import React, { useEffect, useState } from "react";
import { RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useCart } from "../context/CartContext";
import { useMT } from "../lib/miniI18n";
import { fmt } from "../lib/format";

/* One tap: re-add the numbers from the customer's most recent booking on this game to the cart. */
export default function RepeatLastRound({ game, disabled }) {
  const { addItem } = useCart();
  const mt = useMT();
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  useEffect(() => { api.get("/bets/last-booking", { params: { game_id: game.id } }).then((r) => setLast(r.data)).catch(() => {}); }, [game.id]);
  if (!last?.items?.length) return null;
  const repeat = async () => {
    setBusy(true);
    try {
      const seen = new Set(); let added = 0;
      for (const it of last.items) {
        const k = `${it.slat_id}|${it.number}|${it.mode}`;
        if (seen.has(k)) continue; seen.add(k);
        addItem(it); added += 1;
      }
      toast.success(`${added} ${mt("numbers re-added to cart")} · ${fmt(last.total)}`);
    } finally { setBusy(false); }
  };
  const when = new Date(last.placed_at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <button onClick={repeat} disabled={disabled || busy} className="w-full rl-card border-dashed border-amber-300 py-2.5 rounded-2xl flex items-center justify-center gap-2 text-xs font-bold text-amber-800 disabled:opacity-50" data-testid="repeat-last-round-btn">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RotateCcw className="w-4 h-4" />}
      {mt("Repeat last booking")} · {last.items.length} {mt("numbers")} · {fmt(last.total)} <span className="font-normal text-amber-700/70">({when})</span>
    </button>
  );
}
